import styled from 'styled-components';
import Input from './input';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const FieldsWrapper = styled.div`
  width: 100%;
  padding-top: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Header = styled.header`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #252733;

  h4 {
    margin: 5px 0;
    font-weight: 600;
  }
`;

export const EditWrapper = styled.div`
  display: flex;
  color: #525a67;

  .MuiSvgIcon-root {
    font-size: 18px;
  }
  
  .MuiIconButton-root {
    padding: 6px;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  line-height: 20px;
  font-size: 14px;
  color: #323338;
  margin-right: 20px;

  .MuiFormHelperText-contained {
    margin: 0;
  }

  .title {
    flex-shrink: 0;
    width: 100px;

    .MuiSkeleton-root {
      margin-right: 20px;
    }
  }

  .value {
    flex-grow: 1;

    .MuiSkeleton-root {
      max-width: 280px;
    }
  }

  .title-bold {
    font-weight: bold;
    margin-bottom: 5px;
  }
`;

export const FieldSmall = styled(Field)`
  margin-right: 20px;

  .title {
    font-size: 14px;
    padding-left: 20px;
  }
`;

export const InputStyled = styled(Input)`
  flex-grow: 1;

  .MuiOutlinedInput-input {
    padding: 0 14px;
    height: 37px;
    font-size: 14px;
  }
`;

export const DatepickerWrapper = styled.div`
  flex-grow: 1;

  .MuiTextField-root {
    width: 100%;
  }

  .MuiOutlinedInput-input {
    padding: 10px 14px;
    font-size: 14px;
  }
`;
